import type { TenantFragment } from "@/v2-backoffice-client/tenant/__types__/tenant.fragment"

const tenantStub: TenantFragment = {
  Id: 0,
  Name: "",
  ExternalCustomerId: "",
  CustomerName: null,
  UserCount: 0,
  ActiveUserCount: 0,
  InactiveUserCount: 0,
  RemovedUserCount: 0,
  InvitationCount: 0,
  Configuration: null,
  IsDeleted: false,
}

export default tenantStub
